(function () {
  var VERSION = "20260724-mystery-stable-teaser-r5";
  var bootstrapConfig = window.TeamK9DogOfferTeaserConfig || {};
  // A store-level or recovery loader may execute before the theme has supplied
  // the required asset URLs. Exit without claiming the version so the
  // configured theme include can initialize deterministically.
  if (!String(bootstrapConfig.imageUrl || "").trim()) return;
  if (window.__tk9WelcomeAcquisitionGuardVersion === VERSION) return;
  window.__tk9WelcomeAcquisitionGuardVersion = VERSION;
  if (window.__tk9DogOfferTeaserVersion === VERSION) return;
  window.__tk9DogOfferTeaserVersion = VERSION;

  // Retire cached teaser generations that may still be running from a stale
  // Shopify page-cache shard. The last predecessor (code-unlocked cu1) polls v6;
  // this runtime owns v7 so both cannot keep rebuilding the same badge after
  // recovery loads.
  try {
    window.localStorage.setItem("tk9_dog_offer_teaser", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser2", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser3", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser4", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser5", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser6", "off");
    window.localStorage.setItem("tk9_dog_offer_teaser7", "off");
  } catch (error) {}

  var config = Object.assign({
    enabled: true,
    imageUrl: "",
    successImageUrl: "",
    label: "REVEAL OFFER",
    openingLabel: "OPENING...",
    unlockedLabel: "YOUR 47% CODE",
    celebrationLabel: "CODE UNLOCKED!",
    cardHeading: "CODE UNLOCKED!",
    cardSub: "Stacks with eligible bundles & free-item offers.",
    copyLabel: "COPY CODE",
    copiedLabel: "COPIED ✓",
    applyRetryLabel: "APPLY TO CART",
    appliedText: "✓ WELCOME is applied to your cart",
    pendingText: "Applying to your cart…",
    emptyCartText: "Code saved — it applies automatically at checkout",
    otherCodeText: "Another discount is active — copy your code for later",
    errorText: "Auto-apply hiccuped — copy your code or tap Apply",
    popupId: "",
    firstVisitDelayMs: 3000,
    autoOpenEnabled: true,
    autoOpenDelayMs: 3000,
    autoOpenMobileDelayMs: 3000,
    autoOpenFallbackDwellMs: 3000,
    autoOpenMobileFallbackDwellMs: 3000,
    autoOpenQuietMs: 1400,
    autoOpenCooldownMs: 86400000,
    autoOpenStorageKey: "tk9_welcome_auto_open_guarded_r2",
    autoOpenSessionKey: "tk9_welcome_auto_attempted_guarded_r2",
    autoOpenParam: "tk9_welcome_auto",
    popupSessionKey: "tk9_dog_offer_teaser_active_popup",
    killParam: "tk9_dog_teaser2",
    legacyKillParam: "tk9_dog_teaser",
    storageKey: "tk9_dog_offer_teaser8",
    unlockedStorageKey: "tk9_welcome_code_unlocked",
    dismissStorageKey: "tk9_dog_offer_teaser2_dismissed",
    reentryStorageKey: "tk9_dog_offer_teaser2_reentry",
    frameSelector: "iframe#ps__widget",
    suppressNativeBubble: true,
    stickySelector: [
      "#sticky-add-to-cart",
      ".sticky-add-to-cart",
      ".tk9-stage-dr__stickybar",
      ".tk9-stage--float-dock .tk9-stage__dock",
      ".tk9-stage__dock",
      ".bw-mobile-cta",
      "#PBarNextFrameWrapper",
      "[data-sticky-cart]",
      "[data-sticky-add-to-cart]",
      "[data-tk9-sticky-cart]",
      "[class*='sticky-cart']",
      "[class*='stickybar']",
      "[class*='sticky-bar']",
      "[class*='sticky_atc']",
      "[class*='sticky-atc']",
      "[class*='bottom-cta']",
      "[class*='bottom_bar']",
      "[class*='fixed-bottom']",
      "[class*='fixed_bottom']",
      "[class*='mobile-cta']"
    ].join(", "),
    nativeFindOptions: {
      triggerType: "Delay",
      respectPage: true,
      respectSubscriber: true,
      respectCountry: true,
      respectPlatform: true,
      respectStatus: false
    },
    nativeFindTriggerTypes: ["Delay", "Custom"],
    findRetryMs: 750,
    findMaxAttempts: 40,
    openVerifyMs: 8000,
    openMaxAttempts: 2,
    syncMs: 700,
    unlockPollMs: 2000,
    postCloseWindowMs: 90000,
    celebrationMs: 6500,
    confetti: true,
    nudgeEveryMs: 9000,
    maxNudges: 5
  }, window.TeamK9DogOfferTeaserConfig || {});

  var bootStartedAt = Date.now();

  function readParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return String(params.get(name) || "").toLowerCase();
    } catch (error) {
      return "";
    }
  }

  var killParam = readParam(config.killParam);
  var legacyParam = readParam(config.legacyKillParam);
  var forceMode = killParam === "force";
  var previewUnlocked = killParam === "unlocked";
  var forceAnyPreview = forceMode || previewUnlocked;
  var autoOpenParam = readParam(config.autoOpenParam);
  var forceAutoOpen = autoOpenParam === "force";

  function isCartPath() {
    var path = String(window.location.pathname || "/").replace(/\/+$/, "") || "/";
    return path === "/cart" || /^\/[a-z]{2}(?:-[a-z]{2})?\/cart$/i.test(path);
  }

  function isDisabled() {
    if (isCartPath()) return true;
    if (killParam === "0" || killParam === "off" || killParam === "false") return true;
    if (legacyParam === "0" || legacyParam === "off" || legacyParam === "false") return true;
    if (killParam === "1" || killParam === "on" || forceAnyPreview) return false;
    if (loadUnlocked()) return true;
    try {
      return String(window.localStorage.getItem(config.storageKey) || "").toLowerCase() === "off";
    } catch (error) {
      return false;
    }
  }

  if (!config.enabled || !config.imageUrl || isDisabled()) return;

  var container = null;
  var openButton = null;
  var closeButton = null;
  var dogImage = null;
  var pill = null;
  var styleTag = null;
  var cardEl = null;
  var cardCodeEl = null;
  var cardStatusEl = null;
  var cardCopyBtn = null;
  var cardRetryBtn = null;

  function storedPopupId() {
    try {
      return String(window.sessionStorage.getItem(config.popupSessionKey) || "");
    } catch (error) {
      return "";
    }
  }

  function loadUnlocked() {
    try {
      return Boolean(window.localStorage.getItem(config.unlockedStorageKey));
    } catch (error) {
      return false;
    }
  }

  // A deliberately configured popup is the acquisition source of truth.
  // Session discovery remains the fallback for installs that do not pin one,
  // and for recovery if Postscript rejects a retired configured ID.
  var popupId = String(config.popupId || "") || storedPopupId();
  var popupReady = Boolean(popupId);
  var findInFlight = false;
  var findAttempts = 0;
  var pendingOpen = false;
  var dismissedThisSession = false;
  var reentryThisSession = false;
  var lastPlacementKey = "";
  var syncQueued = false;
  var hiddenBubble = null;
  var openRequestedAt = 0;
  var popupOpen = false;
  var closeGuardUntil = 0;
  var openAttempt = 0;
  var openVerifyTimer = 0;
  var openingFallbackTimer = 0;
  var lastOpenPointerDownAt = 0;
  var isOpening = false;
  var openSource = "manual";
  var autoOpenAttemptedThisSession = false;
  var autoOpenImpressionAt = 0;
  var engagedAt = 0;
  var lastInteractionAt = bootStartedAt;
  var testFlashTimer = 0;

  var unlockedState = loadUnlocked();
  var celebrationActive = false;
  var celebrationTimer = 0;
  var pendingCelebration = false;
  var cardOpen = false;
  var cardApplyState = "idle";
  var cardConfettiShown = false;
  var copyResetTimer = 0;
  var sawImpression = false;
  var lastCloseAt = 0;
  var subscriberBaseline = null;
  var confettiActive = false;
  var entranceShown = false;
  var nudgeCount = 0;
  var nudgeResetTimer = 0;

  function isUnlockedActive() {
    return previewUnlocked || unlockedState;
  }

  function discountCode() {
    var bridge = window.TeamK9WelcomeDiscountBridgeConfig;
    var value = bridge && bridge.code ? String(bridge.code) : "WELCOME";
    value = value.trim().toUpperCase().replace(/[^A-Z0-9_-]/g, "");
    return value || "WELCOME";
  }

  function prefersReducedMotion() {
    try {
      return Boolean(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    } catch (error) {
      return false;
    }
  }

  function setQaState(name, value) {
    if ((!forceAnyPreview && !forceAutoOpen) || !container) return;
    container.setAttribute("data-tk9-qa-" + name, String(value == null ? "" : value));
  }

  function updatePill() {
    if (!pill) return;
    var text;
    if (isOpening) text = config.openingLabel;
    else if (celebrationActive) text = config.celebrationLabel;
    else if (isUnlockedActive()) text = config.unlockedLabel;
    else text = config.label;
    if (pill.textContent !== text) pill.textContent = text;
  }

  function setOpeningState(active) {
    isOpening = Boolean(active);
    if (container) container.classList.toggle("is-opening", isOpening);
    if (openButton) {
      if (isOpening) openButton.setAttribute("aria-busy", "true");
      else openButton.removeAttribute("aria-busy");
    }
    updatePill();
  }

  function clearOpeningFallback() {
    window.clearTimeout(openingFallbackTimer);
    openingFallbackTimer = 0;
  }

  // If Postscript never becomes openable (SDK missing on this page), do not
  // leave the pill on OPENING... forever — settle back to the idle label.
  function scheduleOpeningFallback() {
    clearOpeningFallback();
    var waitMs = forceMode && !postscriptPopups() ? 1200 : config.openVerifyMs + 2500;
    openingFallbackTimer = window.setTimeout(function () {
      openingFallbackTimer = 0;
      if (!pendingOpen || openRequestedAt || openVerifyTimer) return;
      if (forceMode && !postscriptPopups()) {
        pendingOpen = false;
        setOpeningState(false);
        flashTestFeedback();
        return;
      }
      setOpeningState(false);
    }, waitMs);
  }

  function rememberPopupId(nextPopupId) {
    var normalizedId = nextPopupId == null ? "" : String(nextPopupId);
    if (!normalizedId) return false;
    popupId = normalizedId;
    popupReady = true;
    try {
      window.sessionStorage.setItem(config.popupSessionKey, normalizedId);
    } catch (error) {}
    return true;
  }

  function forgetPopupId() {
    popupId = "";
    popupReady = false;
    try {
      window.sessionStorage.removeItem(config.popupSessionKey);
    } catch (error) {}
  }

  function isDismissed() {
    if (dismissedThisSession) return true;
    try {
      return window.sessionStorage.getItem(config.dismissStorageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function rememberDismissed() {
    dismissedThisSession = true;
    reentryThisSession = false;
    try {
      window.sessionStorage.setItem(config.dismissStorageKey, "1");
      window.sessionStorage.removeItem(config.reentryStorageKey);
    } catch (error) {}
  }

  function clearDismissed() {
    dismissedThisSession = false;
    try {
      window.sessionStorage.removeItem(config.dismissStorageKey);
    } catch (error) {}
  }

  function isReentryEnabled() {
    if (reentryThisSession) return true;
    try {
      return window.sessionStorage.getItem(config.reentryStorageKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function enableReentry() {
    reentryThisSession = true;
    try {
      window.sessionStorage.setItem(config.reentryStorageKey, "1");
    } catch (error) {}
  }

  // ---------- Postscript native popup API ----------

  function postscriptPopups() {
    var postscript = window.postscript;
    if (!postscript || typeof postscript !== "object") return null;
    var popups = postscript.popups;
    if (!popups || typeof popups.find !== "function" || typeof popups.open !== "function") return null;
    return popups;
  }

  function currentSubscriberId() {
    try {
      var postscript = window.postscript;
      if (!postscript || typeof postscript.getSubscriberId !== "function") return "";
      var value = postscript.getSubscriberId();
      return value == null ? "" : String(value);
    } catch (error) {
      return "";
    }
  }

  function captureSubscriberBaseline() {
    if (subscriberBaseline !== null) return;
    if (!window.postscript || typeof window.postscript.getSubscriberId !== "function") return;
    subscriberBaseline = currentSubscriberId();
  }

  function syncWelcomeProfile(values) {
    var fields = values && typeof values === "object" ? values : {};
    var email = String(fields.email || fields.Email || "").trim().toLowerCase();
    if (!email || email.indexOf("@") < 1) return;
    var dogName = String(
      fields.DogsName || fields.dogsName || fields.dog_name || fields["Dog's Name"] || ""
    ).trim();
    var properties = {
      email: email,
      tk9_welcome_source: "mystery_guarded_auto",
      tk9_popup_id: popupId,
      tk9_popup_variant: "mystery",
      tk9_signup_path: String(window.location.pathname || "/")
    };
    if (dogName) properties.DogsName = dogName;
    try {
      var queue = window.klaviyo && typeof window.klaviyo.push === "function"
        ? window.klaviyo
        : (window.klaviyo = window.klaviyo || []);
      queue.push(["identify", properties]);
    } catch (error) {}
  }

  // ---------- guarded automatic welcome exposure ----------

  function autoOpenWasAttempted() {
    if (autoOpenAttemptedThisSession) return true;
    if (forceAutoOpen) return false;
    try {
      return window.sessionStorage.getItem(config.autoOpenSessionKey) === "1";
    } catch (error) {
      return false;
    }
  }

  function rememberAutoOpenAttempt() {
    autoOpenAttemptedThisSession = true;
    try {
      window.sessionStorage.setItem(config.autoOpenSessionKey, "1");
    } catch (error) {}
  }

  function lastAutoOpenImpression() {
    if (autoOpenImpressionAt) return autoOpenImpressionAt;
    try {
      var stored = Number(window.localStorage.getItem(config.autoOpenStorageKey) || 0);
      return Number.isFinite(stored) && stored > 0 ? stored : 0;
    } catch (error) {
      return 0;
    }
  }

  function rememberAutoOpenImpression() {
    autoOpenImpressionAt = Date.now();
    try {
      window.localStorage.setItem(config.autoOpenStorageKey, String(autoOpenImpressionAt));
    } catch (error) {}
  }

  function autoOpenCooldownActive() {
    if (forceAutoOpen) return false;
    var lastImpression = lastAutoOpenImpression();
    var cooldown = Math.max(0, Number(config.autoOpenCooldownMs) || 0);
    return Boolean(lastImpression && Date.now() - lastImpression < cooldown);
  }

  function cartSurfaceIsOpen() {
    var root = document.documentElement;
    var body = document.body;
    if ((root && root.classList.contains("tk9-slide-cart-lock")) ||
        (body && body.classList.contains("tk9-slide-cart-lock"))) return true;
    var drawer = document.querySelector("[data-tk9-slide-cart]");
    if (!drawer) return false;
    return drawer.classList.contains("is-open") || drawer.getAttribute("aria-hidden") === "false";
  }

  function purchaseInputHasFocus() {
    var active = document.activeElement;
    if (!active || active === document.body) return false;
    if (active.isContentEditable) return true;
    return /^(INPUT|SELECT|TEXTAREA)$/.test(String(active.tagName || ""));
  }

  function noteVisitorEngagement(event) {
    if (event && event.type === "scroll" && Math.abs(Number(window.scrollY) || 0) < 48) return;
    var now = Date.now();
    if (!engagedAt) engagedAt = now;
    lastInteractionAt = now;
  }

  function autoOpenTimingIsReady() {
    var elapsed = Date.now() - bootStartedAt;
    if (forceAutoOpen) return elapsed >= 500;
    var mobile = window.innerWidth <= 640;
    var engagedDelay = Math.max(0, Number(mobile ? config.autoOpenMobileDelayMs : config.autoOpenDelayMs) || 0);
    var fallbackDelay = Math.max(
      engagedDelay,
      Number(mobile ? config.autoOpenMobileFallbackDwellMs : config.autoOpenFallbackDwellMs) || 0
    );
    return elapsed >= fallbackDelay || Boolean(engagedAt && elapsed >= engagedDelay);
  }

  function autoOpenIsEligible() {
    if (!config.autoOpenEnabled || !popupReady || isDisabled()) return false;
    if ((!forceAutoOpen && (isDismissed() || isUnlockedActive())) || popupOpen || pendingOpen || isOpening) return false;
    if (autoOpenWasAttempted() || autoOpenCooldownActive()) return false;
    if (document.hidden || (!forceAutoOpen && currentSubscriberId())) return false;
    // Never interrupt the primary PDP buying decision. Automatic acquisition
    // may resume only after the shopper has moved past the product's ATC.
    if (cartSurfaceIsOpen() || popupOwnsFrame() || primaryPdpDecisionIsAhead()) return false;
    if (purchaseInputHasFocus()) return false;
    if (Date.now() - lastInteractionAt < Math.max(0, Number(config.autoOpenQuietMs) || 0)) return false;
    return autoOpenTimingIsReady();
  }

  function requestAutoOpen() {
    if (!autoOpenIsEligible()) return false;
    rememberAutoOpenAttempt();
    openSource = "auto";
    setQaState("auto-open", "requested");
    setOpeningState(true);
    preloadSuccessImage();
    pendingOpen = true;
    popupOpen = false;
    openAttempt = 0;
    clearOpenVerification();
    scheduleOpeningFallback();
    if (popupReady) return openPopupNow();
    findPopup();
    return true;
  }

  function findEligiblePopup(popups) {
    var baseOptions = Object.assign({}, config.nativeFindOptions || {});
    if (forceAutoOpen) {
      baseOptions.respectSubscriber = false;
      baseOptions.respectPage = false;
      baseOptions.respectCountry = false;
      baseOptions.respectPlatform = false;
      baseOptions.respectStatus = false;
    }
    var triggerTypes = Array.isArray(config.nativeFindTriggerTypes)
      ? config.nativeFindTriggerTypes.slice()
      : [baseOptions.triggerType || "Delay"];
    triggerTypes = triggerTypes.filter(function (value, index, values) {
      return value && values.indexOf(value) === index;
    });
    if (!triggerTypes.length) triggerTypes = ["Delay"];

    function tryTrigger(index) {
      if (index >= triggerTypes.length) return Promise.resolve(undefined);
      var options = Object.assign({}, baseOptions, { triggerType: triggerTypes[index] });
      return Promise.resolve(popups.find(options)).then(function (foundId) {
        return foundId || tryTrigger(index + 1);
      });
    }

    return tryTrigger(0);
  }

  function findPopup() {
    if (findInFlight || popupReady || (isDismissed() && !forceAnyPreview)) return;
    var popups = postscriptPopups();
    if (!popups) {
      setQaState("find", "sdk-missing");
      return;
    }
    setQaState("find", "searching");
    findInFlight = true;
    findAttempts += 1;
    Promise.resolve()
      .then(function () {
        return findEligiblePopup(popups);
      })
      .then(function (foundId) {
        setQaState("find", foundId ? "found" : "none");
        setQaState("found-id", foundId || "");
        if (foundId) {
          rememberPopupId(foundId);
          if (pendingOpen) {
            window.setTimeout(openPopupNow, 0);
          }
        }
        queueSync();
      })
      .catch(function (error) {
        setQaState("find", "error");
        setQaState("find-error", error && error.message ? error.message : "unknown");
      })
      .finally(function () {
        findInFlight = false;
      });
  }

  function clearOpenVerification() {
    window.clearTimeout(openVerifyTimer);
    openVerifyTimer = 0;
  }

  function popupLooksOpen() {
    if (popupOpen || popupOwnsFrame()) return true;
    var frame = document.querySelector(config.frameSelector);
    if (!frame) return false;
    var rect = frame.getBoundingClientRect();
    var frameStyle = window.getComputedStyle(frame);
    if (frameStyle.display === "none" || frameStyle.visibility === "hidden") return false;
    return rect.width > 380 || rect.height > 220;
  }

  function verifyOpenAttempt() {
    openVerifyTimer = 0;
    if (popupLooksOpen()) {
      setQaState("open", "confirmed");
      pendingOpen = false;
      setOpeningState(false);
      return;
    }
    if (!pendingOpen) return;
    openRequestedAt = 0;
    setQaState("open", "missed");
    forgetPopupId();
    if (openAttempt >= config.openMaxAttempts) {
      pendingOpen = false;
      setOpeningState(false);
      queueSync();
      return;
    }
    findPopup();
  }

  function scheduleOpenVerification() {
    clearOpenVerification();
    openVerifyTimer = window.setTimeout(verifyOpenAttempt, config.openVerifyMs);
  }

  function openPopupNow() {
    // Race guard: an attempt is already in flight (three async callers can
    // otherwise land here back-to-back and double-open one physical tap).
    if (openVerifyTimer) return false;
    if (openRequestedAt && Date.now() - openRequestedAt < config.openVerifyMs) return false;
    var popups = postscriptPopups();
    if (!popupId) {
      pendingOpen = true;
      findPopup();
      return false;
    }
    if (!popups) {
      pendingOpen = true;
      return false;
    }
    pendingOpen = true;
    openRequestedAt = Date.now();
    openAttempt += 1;
    setQaState("open", "attempting");
    setQaState("open-id", popupId);
    setQaState("open-attempt", openAttempt);
    releaseBubble();

    function handleOpenFailure(error) {
      if (!pendingOpen && popupOpen) return;
      setQaState("open", "error");
      setQaState("open-error", error && error.message ? error.message : "unknown");
      clearOpenVerification();
      openRequestedAt = 0;
      forgetPopupId();
      if (openAttempt >= config.openMaxAttempts) {
        pendingOpen = false;
        setOpeningState(false);
      } else {
        findPopup();
      }
    }

    try {
      // The dog is already the visitor's explicit micro-yes. A prior soft-close
      // must not turn that click into Postscript's compact teaser state.
      var openResult = popups.open(popupId, {
        activePopupBehavior: "DISMISS_WHEN_SOFT_CLOSED",
        respectPopupStatus: false,
        // A human click is an explicit request and may reopen the form. The
        // automatic path still honors Postscript's own cooldown in addition
        // to Team K9's local one-day exposure cap.
        respectCooldown: openSource === "auto" && !forceAutoOpen
      });
      if (openResult && typeof openResult.then === "function") {
        Promise.resolve(openResult).catch(handleOpenFailure);
      }
      scheduleOpenVerification();
      return true;
    } catch (error) {
      handleOpenFailure(error);
      return false;
    }
  }

  function handleOpenClick(event) {
    if (event && event.type === "click" && Date.now() - lastOpenPointerDownAt < 800) {
      if (event.preventDefault) event.preventDefault();
      setQaState("synthetic-click", "coalesced");
      return;
    }
    if (Date.now() < closeGuardUntil) {
      if (event && event.preventDefault) event.preventDefault();
      return;
    }
    if (event && event.preventDefault) event.preventDefault();
    if (celebrationActive || isUnlockedActive()) {
      if (cardOpen) closeCard(false);
      else openCard();
      return;
    }
    try {
      var routeEvent = new CustomEvent("tk9WelcomeTeaserOpenRequest", { cancelable: true, detail: { source: "dog_teaser" } });
      if (!window.dispatchEvent(routeEvent)) {
        setOpeningState(false);
        return;
      }
    } catch (error) {}
    if (pendingOpen && (openVerifyTimer || findInFlight || openRequestedAt)) {
      setQaState("repeat-click", "coalesced");
      return;
    }
    openSource = "manual";
    setOpeningState(true);
    preloadSuccessImage();
    pendingOpen = true;
    popupOpen = false;
    openAttempt = 0;
    clearOpenVerification();
    scheduleOpeningFallback();
    if (popupReady) {
      openPopupNow();
      return;
    }
    findPopup();
  }

  function handleOpenPointerDown(event) {
    if (event && event.isPrimary === false) return;
    if (event && typeof event.button === "number" && event.button !== 0) return;
    lastOpenPointerDownAt = Date.now();
    handleOpenClick(event);
  }

  function flashTestFeedback() {
    if (!pill) return;
    window.clearTimeout(testFlashTimer);
    pill.textContent = "CLICK OK (TEST)";
    container.classList.add("is-test-open");
    testFlashTimer = window.setTimeout(function () {
      container.classList.remove("is-test-open");
      updatePill();
    }, 1600);
  }

  function handleCloseClick(event) {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();
    if (event && event.stopImmediatePropagation) event.stopImmediatePropagation();
    closeGuardUntil = Date.now() + 800;
    rememberDismissed();
    pendingOpen = false;
    setOpeningState(false);
    clearOpenVerification();
    clearOpeningFallback();
    stopCelebration();
    closeCard(false);
    hideTeaser();
    queueSync();
  }

  function eventPoint(event) {
    var source = event && event.touches && event.touches[0]
      ? event.touches[0]
      : event && event.changedTouches && event.changedTouches[0]
        ? event.changedTouches[0]
        : event;
    if (!source || typeof source.clientX !== "number" || typeof source.clientY !== "number") return null;
    return { x: source.clientX, y: source.clientY };
  }

  function handleCloseHitZone(event) {
    if (!closeButton || !closeButton.isConnected) return;
    var path = event && event.composedPath ? event.composedPath() : [];
    var directlyTargeted = path.indexOf(closeButton) !== -1;
    var point = eventPoint(event);
    var rect = closeButton.getBoundingClientRect();
    var insideHitbox = point &&
      point.x >= rect.left && point.x <= rect.right &&
      point.y >= rect.top && point.y <= rect.bottom;
    if (directlyTargeted || insideHitbox) handleCloseClick(event);
  }

  // ---------- Postscript mini-bubble suppression ----------
  // While our teaser is on screen (or dismissed for the session), Postscript's
  // own minimized launcher bubble is hidden in place: visibility + pointer
  // events only, never geometry, never opacity-but-clickable. Anything larger
  // than bubble size (an expanded/opening popup) is never touched, and any
  // open request releases the bubble first.

  function popupOwnsFrame() {
    if (document.querySelector("postscript-popup")) return true;
    return document.documentElement.classList.contains("ps-scroll-lock") ||
      document.body.classList.contains("ps-scroll-lock");
  }

  function isVisibleBubble(frame) {
    if (!frame) return false;
    var rect = frame.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    if (rect.width > 380 || rect.height > 220) return false;
    var frameStyle = window.getComputedStyle(frame);
    if (frameStyle.display === "none" || frameStyle.visibility === "hidden") return false;
    if (Number(frameStyle.opacity || 1) <= 0) return false;
    return true;
  }

  function suppressBubble(frame) {
    if (!frame || frame.getAttribute("data-tk9-bubble-suppressed") === VERSION) return;
    frame.__tk9BubbleStyleSnapshot = {
      visibility: frame.style.getPropertyValue("visibility"),
      visibilityPriority: frame.style.getPropertyPriority("visibility"),
      pointerEvents: frame.style.getPropertyValue("pointer-events"),
      pointerEventsPriority: frame.style.getPropertyPriority("pointer-events")
    };
    frame.setAttribute("data-tk9-bubble-suppressed", VERSION);
    frame.style.setProperty("visibility", "hidden", "important");
    frame.style.setProperty("pointer-events", "none", "important");
    hiddenBubble = frame;
  }

  function hideBubble() {
    if (!config.suppressNativeBubble) {
      releaseBubble();
      return;
    }
    // The launcher and expanded popup reuse the same iframe. Release our
    // styles as soon as Postscript starts opening or locks page scrolling.
    if ((openRequestedAt && Date.now() - openRequestedAt < 10000) || popupOwnsFrame()) {
      releaseBubble();
      return;
    }
    var frame = document.querySelector(config.frameSelector);
    if (frame && frame.getAttribute("data-tk9-bubble-suppressed") === VERSION) {
      var suppressedRect = frame.getBoundingClientRect();
      if (suppressedRect.width > 380 || suppressedRect.height > 220) releaseBubble();
      return;
    }
    if (!isVisibleBubble(frame)) {
      releaseBubble();
      return;
    }
    suppressBubble(frame);
  }

  function releaseBubble() {
    var frame = hiddenBubble || document.querySelector(config.frameSelector);
    hiddenBubble = null;
    if (!frame || frame.getAttribute("data-tk9-bubble-suppressed") !== VERSION) return;
    var snapshot = frame.__tk9BubbleStyleSnapshot || {};
    if (snapshot.visibility) {
      frame.style.setProperty("visibility", snapshot.visibility, snapshot.visibilityPriority || "");
    } else {
      frame.style.removeProperty("visibility");
    }
    if (snapshot.pointerEvents) {
      frame.style.setProperty("pointer-events", snapshot.pointerEvents, snapshot.pointerEventsPriority || "");
    } else {
      frame.style.removeProperty("pointer-events");
    }
    frame.removeAttribute("data-tk9-bubble-suppressed");
    try {
      delete frame.__tk9BubbleStyleSnapshot;
    } catch (error) {}
  }

  // ---------- signup success detection + unlocked state ----------

  var successImagePreloaded = false;

  function preloadSuccessImage() {
    if (successImagePreloaded || !config.successImageUrl) return;
    successImagePreloaded = true;
    var preload = new Image();
    preload.src = config.successImageUrl;
  }

  function currentDogImageUrl() {
    return celebrationActive && config.successImageUrl ? config.successImageUrl : config.imageUrl;
  }

  function updateDogImage() {
    if (!dogImage) return;
    var nextSrc = currentDogImageUrl();
    if (dogImage.dataset.tk9Src !== nextSrc) {
      dogImage.src = nextSrc;
      dogImage.dataset.tk9Src = nextSrc;
    }
  }

  function unlockCode(source) {
    if (unlockedState || previewUnlocked) return;
    unlockedState = true;
    try {
      window.localStorage.setItem(config.unlockedStorageKey, new Date().toISOString());
    } catch (error) {}
    // The signup is complete. Keep the earned code, but retire every teaser
    // surface so it cannot compete with the success screen or shopping flow.
    rememberDismissed();
    pendingOpen = false;
    setOpeningState(false);
    clearOpenVerification();
    clearOpeningFallback();
    stopCelebration();
    closeCard(false);
    hideTeaser();
    cardApplyState = "pending";
    setQaState("unlock", source || "unknown");
    try {
      window.dispatchEvent(new CustomEvent("tk9WelcomeSignupSuccess", {
        detail: { code: discountCode(), source: source || "" }
      }));
    } catch (error) {}
    pendingCelebration = false;
    queueSync();
  }

  function startCelebration() {
    if (celebrationActive) return;
    celebrationActive = true;
    preloadSuccessImage();
    window.clearTimeout(celebrationTimer);
    celebrationTimer = window.setTimeout(function () {
      celebrationTimer = 0;
      celebrationActive = false;
      queueSync();
    }, config.celebrationMs);
    confettiBurst(90);
    queueSync();
  }

  function stopCelebration() {
    window.clearTimeout(celebrationTimer);
    celebrationTimer = 0;
    celebrationActive = false;
    pendingCelebration = false;
  }

  function pollSubscriberTransition() {
    if (unlockedState || previewUnlocked) return;
    if (!sawImpression) return;
    if (!popupOpen && (!lastCloseAt || Date.now() - lastCloseAt > config.postCloseWindowMs)) return;
    if (subscriberBaseline === null) {
      captureSubscriberBaseline();
      return;
    }
    if (subscriberBaseline === "" && currentSubscriberId()) unlockCode("subscriber");
  }

  function handleSuccessEvent() {
    unlockCode("event");
  }

  function maybeHandlePostscriptSuccessMessage(event) {
    if (!sawImpression || unlockedState) return;
    var data = event && event.data;
    var text = "";
    if (typeof data === "string") {
      text = data;
    } else {
      try {
        text = JSON.stringify(data);
      } catch (error) {
        text = "";
      }
    }
    text = text.toLowerCase();
    if (!text) return;
    if (!/(postscript|ps__|popup|subscriber|subscription|optin|opt-in|sms|email)/.test(text)) return;
    if (!/(success|submitted|complete|completed|confirmed|subscribed|opted|opted_in|opted-in)/.test(text)) return;
    unlockCode("message");
  }

  function handlePostscriptPopupEvent(event) {
    var detail = event && event.detail;
    if (!detail || !detail.type) return;
    var eventPopupId = detail.popupId == null ? "" : String(detail.popupId);
    setQaState("event", detail.type);
    setQaState("event-id", eventPopupId);
    if (eventPopupId) rememberPopupId(eventPopupId);

    if (detail.type === "formSubmit") {
      syncWelcomeProfile(detail.values && typeof detail.values === "object" ? detail.values : detail);
      return;
    }

    if (detail.type === "impression") {
      popupOpen = true;
      sawImpression = true;
      if (openSource === "auto") rememberAutoOpenImpression();
      captureSubscriberBaseline();
      pendingOpen = false;
      openAttempt = 0;
      setOpeningState(false);
      clearOpenVerification();
      clearOpeningFallback();
      releaseBubble();
      closeCard(false);
      hideTeaser();
      return;
    }

    if (detail.type !== "close") return;
    openRequestedAt = 0;
    popupOpen = false;
    lastCloseAt = Date.now();
    pendingOpen = false;
    openAttempt = 0;
    setOpeningState(false);
    clearOpenVerification();
    clearOpeningFallback();
    pollSubscriberTransition();
    if (pendingCelebration) {
      pendingCelebration = false;
      startCelebration();
    } else if (!celebrationActive && !isUnlockedActive()) {
      enableReentry();
    }
    queueSync();
  }

  // ---------- confetti ----------

  function confettiBurst(count) {
    if (!config.confetti || confettiActive) return;
    if (document.hidden || prefersReducedMotion()) return;
    var canvas = document.createElement("canvas");
    var context2d = canvas.getContext && canvas.getContext("2d");
    if (!context2d) return;
    confettiActive = true;
    var ratio = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = Math.round(window.innerWidth * ratio);
    canvas.height = Math.round(window.innerHeight * ratio);
    canvas.style.cssText = "position:fixed;inset:0;width:100%;height:100%;z-index:2147483002;pointer-events:none";
    canvas.setAttribute("aria-hidden", "true");
    document.body.appendChild(canvas);
    context2d.scale(ratio, ratio);

    var mobile = window.innerWidth <= 640;
    var total = Math.round(count * (mobile ? 0.7 : 1));
    var originRect = container && !container.classList.contains("is-hidden")
      ? container.getBoundingClientRect()
      : { left: 18, top: window.innerHeight - 120, width: 200 };
    var originX = originRect.left + Math.min(originRect.width, 200) * 0.5;
    var originY = originRect.top + 8;
    var colors = ["#162846", "#f5c542", "#ffffff", "#4a90d9", "#e8b04b"];
    var particles = [];
    for (var index = 0; index < total; index += 1) {
      particles.push({
        x: originX + (Math.random() - 0.5) * 60,
        y: originY + (Math.random() - 0.5) * 16,
        vx: (Math.random() - 0.32) * 9.5,
        vy: -(5.5 + Math.random() * 9),
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.32,
        w: 5 + Math.random() * 5,
        h: 8 + Math.random() * 7,
        round: Math.random() < 0.28,
        color: colors[index % colors.length]
      });
    }

    var startedAt = Date.now();
    var rafId = 0;
    var failsafe = 0;

    function cleanup() {
      if (rafId) window.cancelAnimationFrame(rafId);
      window.clearTimeout(failsafe);
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      confettiActive = false;
    }

    function tick() {
      var elapsed = Date.now() - startedAt;
      if (elapsed > 1900) {
        cleanup();
        return;
      }
      context2d.clearRect(0, 0, window.innerWidth, window.innerHeight);
      var alive = false;
      for (var pIndex = 0; pIndex < particles.length; pIndex += 1) {
        var p = particles[pIndex];
        p.vy += 0.34;
        p.vx *= 0.992;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        if (p.y < window.innerHeight + 30) alive = true;
        context2d.save();
        context2d.translate(p.x, p.y);
        context2d.rotate(p.rot);
        context2d.globalAlpha = elapsed > 1400 ? Math.max(0, 1 - (elapsed - 1400) / 500) : 1;
        context2d.fillStyle = p.color;
        if (p.round) {
          context2d.beginPath();
          context2d.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          context2d.fill();
        } else {
          context2d.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        context2d.restore();
      }
      if (!alive) {
        cleanup();
        return;
      }
      rafId = window.requestAnimationFrame(tick);
    }

    failsafe = window.setTimeout(cleanup, 2600);
    rafId = window.requestAnimationFrame(tick);
  }

  // ---------- success card ----------

  function copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () {
        return true;
      }).catch(function () {
        return legacyCopyText(text);
      });
    }
    return Promise.resolve(legacyCopyText(text));
  }

  function legacyCopyText(text) {
    var input = document.createElement("textarea");
    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.left = "-9999px";
    input.style.top = "0";
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, text.length);
    var ok = false;
    try {
      ok = document.execCommand("copy");
    } catch (error) {}
    input.remove();
    return ok;
  }

  function handleCopyClick(event) {
    if (event && event.preventDefault) event.preventDefault();
    var code = discountCode();
    copyTextToClipboard(code).then(function (copied) {
      if (!cardCopyBtn) return;
      window.clearTimeout(copyResetTimer);
      cardCopyBtn.textContent = copied ? config.copiedLabel : config.copyLabel;
      if (copied) {
        copyResetTimer = window.setTimeout(function () {
          if (cardCopyBtn) cardCopyBtn.textContent = config.copyLabel;
        }, 1800);
      }
    });
  }

  function requestApply() {
    cardApplyState = "pending";
    renderCard();
    try {
      window.dispatchEvent(new CustomEvent("tk9WelcomeApplyRequest", {
        detail: { code: discountCode(), source: "card" }
      }));
    } catch (error) {}
  }

  var applyResultSeen = false;

  function handleApplyResult(event) {
    var detail = event && event.detail;
    if (!detail) return;
    applyResultSeen = true;
    if (detail.applied) cardApplyState = "applied";
    else if (detail.reason === "other_code") cardApplyState = "other_code";
    else if (detail.reason === "empty_cart") cardApplyState = "empty_cart";
    else cardApplyState = "error";
    renderCard();
  }

  function renderCard() {
    if (!cardEl) return;
    if (cardCodeEl) cardCodeEl.textContent = discountCode();
    var statusText = "";
    var statusGood = false;
    var showRetry = false;
    if (cardApplyState === "applied") {
      statusText = config.appliedText;
      statusGood = true;
    } else if (cardApplyState === "pending") {
      statusText = config.pendingText;
    } else if (cardApplyState === "empty_cart") {
      statusText = config.emptyCartText;
      statusGood = true;
    } else if (cardApplyState === "other_code") {
      statusText = config.otherCodeText;
    } else if (cardApplyState === "error") {
      statusText = config.errorText;
      showRetry = true;
    }
    if (cardStatusEl) {
      cardStatusEl.textContent = statusText;
      cardStatusEl.classList.toggle("is-good", statusGood);
    }
    if (cardRetryBtn) cardRetryBtn.style.display = showRetry ? "block" : "none";
  }

  function ensureCard() {
    if (cardEl && cardEl.isConnected) return;
    var existing = document.getElementById("tk9-dog-offer-card2");
    if (existing) existing.remove();

    cardEl = document.createElement("div");
    cardEl.id = "tk9-dog-offer-card2";
    cardEl.className = "is-hidden";
    cardEl.setAttribute("role", "dialog");
    cardEl.setAttribute("aria-label", "Your Team K9 welcome code");

    var heading = document.createElement("p");
    heading.className = "tk9-dog-offer-card2__heading";
    heading.textContent = config.cardHeading;

    var image = document.createElement("img");
    image.className = "tk9-dog-offer-card2__img";
    image.alt = "";
    image.setAttribute("role", "presentation");
    if (config.successImageUrl) image.src = config.successImageUrl;
    else image.style.display = "none";

    cardCodeEl = document.createElement("div");
    cardCodeEl.className = "tk9-dog-offer-card2__code";

    cardCopyBtn = document.createElement("button");
    cardCopyBtn.type = "button";
    cardCopyBtn.className = "tk9-dog-offer-card2__copy";
    cardCopyBtn.textContent = config.copyLabel;
    cardCopyBtn.addEventListener("click", handleCopyClick);

    cardStatusEl = document.createElement("p");
    cardStatusEl.className = "tk9-dog-offer-card2__status";

    cardRetryBtn = document.createElement("button");
    cardRetryBtn.type = "button";
    cardRetryBtn.className = "tk9-dog-offer-card2__retry";
    cardRetryBtn.textContent = config.applyRetryLabel;
    cardRetryBtn.style.display = "none";
    cardRetryBtn.addEventListener("click", function (event) {
      if (event && event.preventDefault) event.preventDefault();
      requestApply();
    });

    var sub = document.createElement("p");
    sub.className = "tk9-dog-offer-card2__sub";
    sub.textContent = config.cardSub;

    var cardClose = document.createElement("button");
    cardClose.type = "button";
    cardClose.className = "tk9-dog-offer-card2__close";
    cardClose.setAttribute("aria-label", "Close code panel");
    cardClose.addEventListener("click", function (event) {
      if (event && event.preventDefault) event.preventDefault();
      closeCard(true);
    });

    cardEl.appendChild(cardClose);
    cardEl.appendChild(image);
    cardEl.appendChild(heading);
    cardEl.appendChild(cardCodeEl);
    cardEl.appendChild(cardCopyBtn);
    cardEl.appendChild(cardStatusEl);
    cardEl.appendChild(cardRetryBtn);
    cardEl.appendChild(sub);
    document.body.appendChild(cardEl);
  }

  function positionCard() {
    if (!cardEl) return;
    var place = placement();
    cardEl.style.left = place.left + "px";
    cardEl.style.bottom = Math.max(10, place.bottom + place.height + 10) + "px";
  }

  function openCard() {
    ensureCard();
    // Re-request when no bridge result has ever arrived (covers a signup
    // dispatch the bridge missed) and on retryable failures.
    if (!applyResultSeen || cardApplyState === "idle" || cardApplyState === "error") requestApply();
    renderCard();
    cardEl.classList.remove("is-hidden");
    cardOpen = true;
    positionCard();
    if (!cardConfettiShown && !celebrationActive) {
      cardConfettiShown = true;
      confettiBurst(34);
    }
    try {
      if (cardCopyBtn) cardCopyBtn.focus({ preventScroll: true });
    } catch (error) {}
    queueSync();
  }

  function closeCard(restoreFocus) {
    if (cardEl) cardEl.classList.add("is-hidden");
    var wasOpen = cardOpen;
    cardOpen = false;
    if (restoreFocus && wasOpen && openButton) {
      try {
        openButton.focus({ preventScroll: true });
      } catch (error) {}
    }
  }

  function handleDocumentPointerDown(event) {
    if (!cardOpen || !cardEl) return;
    var target = event && event.target;
    if (!target) return;
    if (cardEl.contains(target)) return;
    if (container && container.contains(target)) return;
    closeCard(false);
  }

  function handleDocumentKeydown(event) {
    if (!cardOpen) return;
    if (event && (event.key === "Escape" || event.key === "Esc")) closeCard(true);
  }

  // ---------- sticky add-to-cart detection ----------

  function isDisplayable(node) {
    if (!node) return false;
    var rect = node.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    var nodeStyle = window.getComputedStyle(node);
    if (nodeStyle.display === "none" || nodeStyle.visibility === "hidden") return false;
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function isBottomAnchoredBar(node) {
    var rect = node.getBoundingClientRect();
    var nodeStyle = window.getComputedStyle(node);
    if (nodeStyle.position !== "fixed" && nodeStyle.position !== "sticky") return false;
    var mobile = window.innerWidth <= 640;
    var bottomSlack = mobile ? 96 : 72;
    if (rect.bottom < window.innerHeight - bottomSlack) return false;
    return rect.top < window.innerHeight && rect.bottom > window.innerHeight * 0.45;
  }

  function overlapsTeaserZone(node) {
    if (window.innerWidth <= 640) return true;
    var rect = node.getBoundingClientRect();
    var teaserLeft = 18;
    var teaserRight = 18 + 230 + 36;
    var overlapsLeft = rect.left < teaserRight && rect.right > teaserLeft;
    var isBroadBar = rect.width >= window.innerWidth * 0.55;
    return overlapsLeft || isBroadBar;
  }

  function stickyBarHeight() {
    var nodes;
    try {
      nodes = document.querySelectorAll(config.stickySelector);
    } catch (error) {
      return 0;
    }
    var best = 0;
    for (var index = 0; index < nodes.length; index += 1) {
      var node = nodes[index];
      if (!node || node === container || (container && container.contains(node))) continue;
      if (node.id === "ps__widget") continue;
      if (!isDisplayable(node) || !isBottomAnchoredBar(node) || !overlapsTeaserZone(node)) continue;
      var height = Math.max(0, window.innerHeight - node.getBoundingClientRect().top);
      if (height > best) best = height;
    }
    return best;
  }

  function placement() {
    var mobile = window.innerWidth <= 640;
    var unlockedBanner = isUnlockedActive() && !celebrationActive;
    var stickyHeight = stickyBarHeight();
    var previewBar = document.getElementById("PBarNextFrameWrapper");
    var previewBarVisible = isDisplayable(previewBar) && isBottomAnchoredBar(previewBar);
    var overlap = mobile || previewBarVisible ? 0 : 8;
    // Bounded: never park the dog above 42% of the viewport no matter what
    // the sticky detection matched.
    var maxBottom = Math.round(window.innerHeight * 0.42);
    var bottom = stickyHeight > 0
      ? Math.min(Math.max(0, Math.round(stickyHeight - overlap)), maxBottom)
      : (mobile ? -5 : -6);
    if (unlockedBanner && bottom < 8) bottom = 8;
    return {
      mobile: mobile,
      unlocked: unlockedBanner,
      left: mobile ? 10 : 18,
      bottom: bottom,
      width: mobile ? (unlockedBanner ? 160 : 212) : (unlockedBanner ? 196 : 262),
      height: mobile ? (unlockedBanner ? 46 : 78) : (unlockedBanner ? 54 : 98)
    };
  }

  // ---------- DOM ----------

  function ensureStyle() {
    var existing = document.getElementById("tk9-dog-offer-teaser2-style");
    if (existing && existing.getAttribute("data-tk9-version") !== VERSION) {
      existing.remove();
      existing = null;
    }
    if (styleTag || existing) return;
    styleTag = document.createElement("style");
    styleTag.id = "tk9-dog-offer-teaser2-style";
    styleTag.setAttribute("data-tk9-version", VERSION);
    styleTag.textContent = [
      "#tk9-dog-offer-teaser2{position:fixed;left:18px;bottom:-6px;width:262px;height:98px;z-index:2147483000;font-family:inherit;overflow:visible;contain:layout style}",
      "#tk9-dog-offer-teaser2.is-hidden{display:none}",
      "#tk9-dog-offer-teaser2 *{box-sizing:border-box}",
      "#tk9-dog-offer-teaser2 button{appearance:none;-webkit-appearance:none;background:transparent;border:0;padding:0;margin:0;font:inherit}",
      // The open button ends exactly at the pill's right edge: the strip
      // beyond it belongs to the close control only, so no invisible area
      // can open the popup and the container still owns retargeted X taps.
      ".tk9-dog-offer-teaser2__open{position:absolute;left:0;top:0;bottom:0;width:218px;display:block;height:100%;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent}",
      "#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__open{width:152px}",
      ".tk9-dog-offer-teaser2__open:focus-visible{outline:2px solid #fff0c2;outline-offset:2px;border-radius:14px}",
      ".tk9-dog-offer-teaser2__dog-mask{position:absolute;left:0;bottom:0;width:214px;height:72px;overflow:hidden;pointer-events:none;filter:drop-shadow(0 10px 16px rgba(5,20,30,.22)) drop-shadow(0 1px 0 rgba(255,255,255,.66));transition:opacity .28s ease,transform .28s ease}",
      ".tk9-dog-offer-teaser2__dog{position:absolute;left:0;bottom:-4px;width:204px;height:auto;max-width:none}",
      "#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__dog{left:9px;bottom:-10px;width:183px}",
      "#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__blink,#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__wink{display:none!important}",
      "#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__dog-mask{opacity:0;transform:translateY(30px);pointer-events:none}",
      "#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__blink,#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__wink{display:none!important}",
      ".tk9-dog-offer-teaser2__blink{position:absolute;z-index:2;width:27px;height:18px;border-radius:999px;background:radial-gradient(ellipse at 50% 42%,rgba(128,74,38,.98) 0%,rgba(83,45,28,.98) 58%,rgba(24,15,13,.98) 100%);box-shadow:inset 0 -2px 2px rgba(17,10,8,.75),0 0 0 1px rgba(20,12,10,.22);opacity:0;pointer-events:none;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(.05);transform-origin:50% 50%;animation:tk9-dog2-blink 11.5s infinite;animation-delay:1.35s}",
      ".tk9-dog-offer-teaser2__blink--left{left:44px;top:22px;--tk9-blink-rotate:4deg}",
      ".tk9-dog-offer-teaser2__blink--right{left:126px;top:22px;--tk9-blink-rotate:-5deg}",
      ".tk9-dog-offer-teaser2__wink{position:absolute;z-index:3;left:126px;top:22px;width:27px;height:18px;border-radius:999px;background:radial-gradient(ellipse at 50% 42%,rgba(128,74,38,.98) 0%,rgba(83,45,28,.98) 58%,rgba(24,15,13,.98) 100%);box-shadow:inset 0 -2px 2px rgba(17,10,8,.75),0 0 0 1px rgba(20,12,10,.22);opacity:0;pointer-events:none;transform:rotate(-5deg) scaleY(.05);transform-origin:50% 50%;animation:tk9-dog2-wink 57.5s infinite}",
      ".tk9-dog-offer-teaser2__pill{position:absolute;left:72px;top:8px;display:flex;align-items:center;justify-content:center;min-width:146px;min-height:29px;padding:8px 12px;border-radius:999px;background:#162846;color:#fff;border:1px solid rgba(255,255,255,.76);box-shadow:0 10px 18px rgba(5,20,30,.22),inset 0 1px 0 rgba(255,255,255,.18);font-size:10px;font-weight:900;line-height:1;letter-spacing:0;text-transform:uppercase;white-space:nowrap;text-shadow:0 1px 0 rgba(0,0,0,.16);pointer-events:none;transition:transform .18s ease,background .18s ease,box-shadow .18s ease}",
      "#tk9-dog-offer-teaser2:not(.is-unlocked) .tk9-dog-offer-teaser2__open:hover .tk9-dog-offer-teaser2__pill{transform:scale(1.045);background:#1b3157;box-shadow:0 13px 24px rgba(5,20,30,.3),inset 0 1px 0 rgba(255,255,255,.18)}",
      "#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__open:hover .tk9-dog-offer-teaser2__pill{transform:scale(1.035);background:#1b3157}",
      "#tk9-dog-offer-teaser2.is-test-open .tk9-dog-offer-teaser2__pill{background:#1d6a3a}",
      "#tk9-dog-offer-teaser2.is-opening .tk9-dog-offer-teaser2__pill{background:#203a63}",
      "#tk9-dog-offer-teaser2.is-celebrating .tk9-dog-offer-teaser2__pill{background:#f5c542;color:#162846;border-color:rgba(22,40,70,.4);text-shadow:none}",
      "#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__pill{left:6px;top:10px}",
      ".tk9-dog-offer-teaser2__close{position:absolute;left:218px;top:-10px;display:flex;align-items:center;justify-content:center;width:44px;height:44px;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;z-index:2}",
      "#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__close{left:152px;top:2px}",
      ".tk9-dog-offer-teaser2__close:before{content:'x';display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:999px;border:1px solid rgba(255,255,255,.72);background:#162846;color:#fff;box-shadow:0 4px 9px rgba(5,20,30,.18);font:900 11px/1 Arial,sans-serif}",
      ".tk9-dog-offer-teaser2__close:hover:before{background:#213b65}",
      ".tk9-dog-offer-teaser2__close:focus-visible{outline:2px solid #fff0c2;outline-offset:2px;border-radius:999px}",
      "@keyframes tk9-dog2-blink{0%,42%,43.55%,100%{opacity:0;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(.05)}42.35%,42.8%{opacity:.95;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(1)}43.15%{opacity:.55;transform:rotate(var(--tk9-blink-rotate,0deg)) scaleY(.36)}}",
      "@keyframes tk9-dog2-wink{0%,23%,23.31%,100%{opacity:0;transform:rotate(-5deg) scaleY(.05)}23.07%,23.16%{opacity:.95;transform:rotate(-5deg) scaleY(1)}23.23%{opacity:.55;transform:rotate(-5deg) scaleY(.36)}}",
      "@keyframes tk9-dog2-enter{0%{transform:translateY(110%);opacity:0}62%{transform:translateY(-6px);opacity:1}100%{transform:translateY(0);opacity:1}}",
      "#tk9-dog-offer-teaser2.is-entering{animation:tk9-dog2-enter .5s cubic-bezier(.2,.8,.3,1)}",
      "@keyframes tk9-dog2-nudge{0%,100%{transform:translateY(0)}20%{transform:translateY(-7px)}40%{transform:translateY(0)}60%{transform:translateY(-4px)}80%{transform:translateY(0)}}",
      "#tk9-dog-offer-teaser2.is-nudging{animation:tk9-dog2-nudge .95s ease-in-out}",
      "#tk9-dog-offer-card2{position:fixed;left:18px;bottom:120px;width:300px;max-width:calc(100vw - 20px);z-index:2147483000;background:#fff;border:1px solid rgba(22,40,70,.16);border-radius:16px;box-shadow:0 18px 48px rgba(5,20,30,.28);padding:18px 16px 14px;font-family:inherit;color:#162846}",
      "#tk9-dog-offer-card2.is-hidden{display:none}",
      "#tk9-dog-offer-card2 *{box-sizing:border-box}",
      "#tk9-dog-offer-card2 button{appearance:none;-webkit-appearance:none;border:0;margin:0;font:inherit}",
      ".tk9-dog-offer-card2__img{display:block;width:112px;height:auto;margin:0 auto 4px;filter:drop-shadow(0 6px 12px rgba(5,20,30,.18))}",
      ".tk9-dog-offer-card2__heading{margin:0 0 10px;font-size:15px;font-weight:900;letter-spacing:.6px;text-align:center;text-transform:uppercase}",
      ".tk9-dog-offer-card2__code{display:flex;align-items:center;justify-content:center;min-height:42px;border:2px dashed rgba(22,40,70,.42);border-radius:10px;background:#fbf6ea;font:900 20px/1 ui-monospace,Menlo,Consolas,monospace;letter-spacing:3px;margin-bottom:10px;-webkit-user-select:all;user-select:all}",
      ".tk9-dog-offer-card2__copy{display:block;width:100%;min-height:42px;border-radius:999px;background:#162846;color:#fff;font-size:12px;font-weight:900;letter-spacing:1px;cursor:pointer;text-transform:uppercase}",
      ".tk9-dog-offer-card2__copy:hover{background:#1b3157}",
      ".tk9-dog-offer-card2__copy:focus-visible,.tk9-dog-offer-card2__retry:focus-visible,.tk9-dog-offer-card2__close:focus-visible{outline:2px solid #16284699;outline-offset:2px}",
      ".tk9-dog-offer-card2__status{margin:9px 0 0;min-height:15px;font-size:11.5px;line-height:1.4;text-align:center;color:#3d5068}",
      ".tk9-dog-offer-card2__status.is-good{color:#1d6a3a;font-weight:700}",
      ".tk9-dog-offer-card2__retry{margin-top:8px;width:100%;min-height:38px;border-radius:999px;border:1.5px solid #162846;color:#162846;background:#fff;font-size:11px;font-weight:900;letter-spacing:1px;cursor:pointer;text-transform:uppercase}",
      ".tk9-dog-offer-card2__retry:hover{background:#f2f5fa}",
      ".tk9-dog-offer-card2__sub{margin:10px 0 0;font-size:10.5px;line-height:1.4;color:#7a8699;text-align:center}",
      ".tk9-dog-offer-card2__close{position:absolute;right:4px;top:4px;display:flex;align-items:center;justify-content:center;width:38px;height:38px;cursor:pointer;background:transparent}",
      ".tk9-dog-offer-card2__close:before{content:'x';display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:999px;border:1px solid rgba(22,40,70,.35);background:#fff;color:#162846;font:900 11px/1 Arial,sans-serif}",
      ".tk9-dog-offer-card2__close:hover:before{background:#f2f5fa}",
      "@media(max-width:640px){#tk9-dog-offer-teaser2{left:10px;bottom:-5px;width:212px;height:78px}.tk9-dog-offer-teaser2__open{width:160px}#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__open{width:112px}.tk9-dog-offer-teaser2__dog-mask{width:154px;height:53px}.tk9-dog-offer-teaser2__dog{left:0;bottom:-3px;width:145px}#tk9-dog-offer-teaser2.is-success .tk9-dog-offer-teaser2__dog{left:7px;bottom:-10px;width:136px}.tk9-dog-offer-teaser2__blink{width:19px;height:13px}.tk9-dog-offer-teaser2__blink--left{left:31px;top:17px}.tk9-dog-offer-teaser2__blink--right{left:90px;top:17px}.tk9-dog-offer-teaser2__wink{left:90px;top:17px;width:19px;height:13px}.tk9-dog-offer-teaser2__pill{left:52px;top:8px;min-width:108px;min-height:24px;padding:7px 9px;font-size:8.8px}#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__pill{left:4px;top:9px}.tk9-dog-offer-teaser2__close{left:160px;top:-12px;width:48px;height:48px}#tk9-dog-offer-teaser2.is-unlocked .tk9-dog-offer-teaser2__close{left:112px;top:-2px}.tk9-dog-offer-teaser2__close:before{width:18px;height:18px;font-size:10px;box-shadow:0 3px 7px rgba(5,20,30,.14)}#tk9-dog-offer-card2{left:10px}}",
      "@media(prefers-reduced-motion:reduce){.tk9-dog-offer-teaser2__blink,.tk9-dog-offer-teaser2__wink{display:none!important;animation:none!important}#tk9-dog-offer-teaser2.is-entering,#tk9-dog-offer-teaser2.is-nudging{animation:none!important}.tk9-dog-offer-teaser2__dog-mask,.tk9-dog-offer-teaser2__pill{transition:none!important}}"
    ].join("");
    document.head.appendChild(styleTag);
  }

  function ensureDom() {
    if (container && container.isConnected) return;
    ensureStyle();
    var existing = document.getElementById("tk9-dog-offer-teaser2");
    if (existing) existing.remove();
    // Also clear any legacy-generation widget nodes left behind by a
    // cached v40-v45 script that booted before we set its kill switch.
    var legacyRoot = document.getElementById("tk9-dog-offer-button");
    if (legacyRoot) legacyRoot.remove();
    var legacyClose = document.getElementById("tk9-dog-offer-close");
    if (legacyClose) legacyClose.remove();

    container = document.createElement("div");
    container.id = "tk9-dog-offer-teaser2";
    container.className = "is-hidden";
    container.addEventListener("pointerdown", handleCloseHitZone, { capture: true });
    container.addEventListener("touchstart", handleCloseHitZone, { capture: true, passive: false });
    container.addEventListener("mousedown", handleCloseHitZone, { capture: true });

    openButton = document.createElement("button");
    openButton.type = "button";
    openButton.className = "tk9-dog-offer-teaser2__open";
    openButton.setAttribute("aria-label", "Reveal Team K9 welcome offer");
    openButton.innerHTML = [
      '<span class="tk9-dog-offer-teaser2__dog-mask">',
      '<img class="tk9-dog-offer-teaser2__dog" alt="" role="presentation">',
      '<span class="tk9-dog-offer-teaser2__blink tk9-dog-offer-teaser2__blink--left" aria-hidden="true"></span>',
      '<span class="tk9-dog-offer-teaser2__blink tk9-dog-offer-teaser2__blink--right" aria-hidden="true"></span>',
      '<span class="tk9-dog-offer-teaser2__wink" aria-hidden="true"></span>',
      "</span>",
      '<span class="tk9-dog-offer-teaser2__pill" aria-hidden="true"></span>'
    ].join("");
    openButton.addEventListener("pointerdown", handleOpenPointerDown);
    openButton.addEventListener("click", handleOpenClick);

    closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "tk9-dog-offer-teaser2__close";
    closeButton.setAttribute("aria-label", "Hide offer teaser");
    closeButton.addEventListener("pointerdown", handleCloseClick, { capture: true });
    closeButton.addEventListener("touchstart", handleCloseClick, { capture: true, passive: false });
    closeButton.addEventListener("mousedown", handleCloseClick, { capture: true });
    closeButton.addEventListener("click", handleCloseClick, { capture: true });

    container.appendChild(openButton);
    container.appendChild(closeButton);
    document.body.appendChild(container);

    dogImage = openButton.querySelector(".tk9-dog-offer-teaser2__dog");
    pill = openButton.querySelector(".tk9-dog-offer-teaser2__pill");
    updatePill();
    updateDogImage();
  }

  function hideTeaser() {
    if (container) container.classList.add("is-hidden");
  }

  function showTeaser() {
    ensureDom();
    var wasHidden = container.classList.contains("is-hidden");
    container.classList.remove("is-hidden");
    if (wasHidden && !entranceShown && !prefersReducedMotion()) {
      entranceShown = true;
      container.classList.add("is-entering");
      window.setTimeout(function () {
        if (container) container.classList.remove("is-entering");
      }, 620);
    } else if (wasHidden) {
      entranceShown = true;
    }
  }

  function applyModeClasses() {
    if (!container) return;
    var celebrating = celebrationActive;
    var unlockedBanner = isUnlockedActive() && !celebrating;
    container.classList.toggle("is-celebrating", celebrating);
    container.classList.toggle("is-success", celebrating);
    container.classList.toggle("is-unlocked", unlockedBanner);
    if (openButton) {
      openButton.setAttribute("aria-label", unlockedBanner || celebrating
        ? "Show your Team K9 welcome code"
        : "Reveal Team K9 welcome offer");
    }
    if (closeButton) {
      closeButton.setAttribute("aria-label", unlockedBanner ? "Hide code reminder" : "Hide offer teaser");
    }
    updatePill();
    updateDogImage();
  }

  function applyPlacement() {
    if (!container || container.classList.contains("is-hidden")) return;
    var place = placement();
    var key = [place.left, place.bottom, place.width, place.height, place.unlocked ? 1 : 0].join(":");
    if (key !== lastPlacementKey) {
      lastPlacementKey = key;
      container.style.left = place.left + "px";
      container.style.bottom = place.bottom + "px";
      container.style.width = place.width + "px";
      container.style.height = place.height + "px";
    }
    if (cardOpen) positionCard();
  }

  // ---------- attention nudge ----------

  function maybeNudge() {
    if (!container || container.classList.contains("is-hidden")) return;
    if (celebrationActive || isUnlockedActive() || cardOpen || isOpening) return;
    if (document.hidden || prefersReducedMotion()) return;
    if (nudgeCount >= config.maxNudges) return;
    if (container.classList.contains("is-nudging") || container.classList.contains("is-entering")) return;
    try {
      if (container.matches(":hover")) return;
    } catch (error) {}
    nudgeCount += 1;
    container.classList.add("is-nudging");
    window.clearTimeout(nudgeResetTimer);
    nudgeResetTimer = window.setTimeout(function () {
      if (container) container.classList.remove("is-nudging");
    }, 980);
  }

  // ---------- sync loop ----------

  function primaryPdpDecisionIsAhead() {
    var stage = document.querySelector("[data-tk9-stage-dr]");
    if (!stage) return false;
    var atc = stage.querySelector("[data-tk9-stage-atc]");
    if (!atc) return false;
    return atc.getBoundingClientRect().bottom >= 0;
  }

  function firstVisitTeaserIsReady() {
    return popupReady && Date.now() - bootStartedAt >= Math.max(0, Number(config.firstVisitDelayMs) || 0);
  }

  function sync() {
    syncQueued = false;
    if (isDisabled()) {
      hideTeaser();
      closeCard(false);
      releaseBubble();
      return;
    }
    if (currentSubscriberId() && !forceAnyPreview && !forceAutoOpen) {
      hideTeaser();
      closeCard(false);
      releaseBubble();
      return;
    }
    if (isDismissed() && !forceAnyPreview) {
      hideTeaser();
      closeCard(false);
      // Session-dismissed means "hide the offer": keep the launcher bubble
      // suppressed too, but never anything larger than a bubble.
      hideBubble();
      return;
    }
    if (autoOpenIsEligible()) {
      requestAutoOpen();
      hideTeaser();
      closeCard(false);
      releaseBubble();
      return;
    }
    if (popupOpen) {
      hideTeaser();
      closeCard(false);
      releaseBubble();
      return;
    }
    // A visible compact Postscript iframe is its minimized badge. Replace that
    // state with the dog, including on later pages for a previously closed
    // visitor. Expanded/full-screen popup frames never satisfy this check.
    if (isVisibleBubble(document.querySelector(config.frameSelector))) enableReentry();
    var unlockedActive = isUnlockedActive();
    if (!popupReady && !unlockedActive) findPopup();
    if (celebrationActive || unlockedActive || isReentryEnabled() || firstVisitTeaserIsReady() || forceMode) {
      showTeaser();
      applyModeClasses();
      hideBubble();
      applyPlacement();
    } else {
      // No openable popup (SDK missing/blocked or visitor ineligible):
      // show nothing of ours and leave Postscript's own surfaces alone.
      hideTeaser();
      closeCard(false);
      releaseBubble();
    }
  }

  function runSyncNow() {
    syncQueued = false;
    sync();
  }

  // Coalesce bursty events through rAF, but never depend on rAF for
  // progress: rAF is paused entirely in hidden/backgrounded tabs, so the
  // interval below always calls runSyncNow directly.
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(runSyncNow);
  }

  function boot() {
    if (!document.body) {
      window.setTimeout(boot, 50);
      return;
    }
    ensureDom();
    sync();
    window.setInterval(runSyncNow, config.syncMs);
    document.addEventListener("visibilitychange", runSyncNow);
    window.setInterval(function () {
      if (pendingOpen && popupId && !openVerifyTimer && openAttempt < config.openMaxAttempts) {
        openPopupNow();
        return;
      }
      if (!popupReady && !isUnlockedActive() && findAttempts < config.findMaxAttempts) findPopup();
    }, config.findRetryMs);
    window.setInterval(pollSubscriberTransition, config.unlockPollMs);
    window.setInterval(maybeNudge, config.nudgeEveryMs);
    window.addEventListener("postscriptReady", function () {
      captureSubscriberBaseline();
      if (pendingOpen && popupId && !openVerifyTimer) openPopupNow();
      findPopup();
      queueSync();
    });
    window.addEventListener("resize", queueSync);
    window.addEventListener("scroll", function (event) {
      noteVisitorEngagement(event);
      queueSync();
    }, { passive: true });
    window.addEventListener("pageshow", queueSync);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", queueSync);
      window.visualViewport.addEventListener("scroll", queueSync);
    }
    window.addEventListener("message", maybeHandlePostscriptSuccessMessage);
    window.addEventListener("postscriptPopup", handlePostscriptPopupEvent);
    window.addEventListener("tk9DogOfferSuccess", handleSuccessEvent);
    window.addEventListener("teamK9DogOfferSuccess", handleSuccessEvent);
    window.addEventListener("tk9WelcomeApplyResult", handleApplyResult);
    document.addEventListener("pointerdown", noteVisitorEngagement, { capture: true, passive: true });
    document.addEventListener("keydown", noteVisitorEngagement, { capture: true });
    document.addEventListener("pointerdown", handleDocumentPointerDown, { capture: true });
    document.addEventListener("keydown", handleDocumentKeydown);

    window.TeamK9DogOfferTeaser = Object.assign(window.TeamK9DogOfferTeaser || {}, {
      version: VERSION,
      setPopupId: function (nextPopupId) {
        var changed = rememberPopupId(nextPopupId);
        if (changed) {
          openAttempt = 0;
          openRequestedAt = 0;
          clearOpenVerification();
          queueSync();
        }
        return changed;
      },
      unlock: function () {
        unlockCode("api");
      },
      celebrate: startCelebration,
      openCard: openCard,
      closeCard: function () {
        closeCard(true);
      },
      confetti: confettiBurst,
      showSuccess: function () {
        unlockCode("api");
        return true;
      },
      clearSuccess: stopCelebration,
      open: handleOpenClick,
      state: function () {
        return {
          version: VERSION,
          popupReady: popupReady,
          popupOpen: popupOpen,
          hasPopupId: Boolean(popupId),
          findAttempts: findAttempts,
          forceMode: forceMode,
          forceAutoOpen: forceAutoOpen,
          firstVisitReady: firstVisitTeaserIsReady(),
          autoOpenEnabled: Boolean(config.autoOpenEnabled),
          autoOpenTimingReady: autoOpenTimingIsReady(),
          autoOpenEligible: autoOpenIsEligible(),
          autoOpenAttempted: autoOpenWasAttempted(),
          autoOpenCooldown: autoOpenCooldownActive(),
          autoOpenSource: openSource,
          engaged: Boolean(engagedAt),
          cartSurfaceOpen: cartSurfaceIsOpen(),
          primaryDecisionAhead: primaryPdpDecisionIsAhead(),
          previewUnlocked: previewUnlocked,
          unlocked: isUnlockedActive(),
          celebration: celebrationActive,
          cardOpen: cardOpen,
          applyState: cardApplyState,
          sawImpression: sawImpression,
          subscriberBaselineCaptured: subscriberBaseline !== null,
          dismissed: isDismissed(),
          reentryEnabled: isReentryEnabled(),
          teaserVisible: Boolean(container && !container.classList.contains("is-hidden")),
          bubblePresent: Boolean(document.querySelector(config.frameSelector)),
          sdkPresent: Boolean(postscriptPopups()),
          placement: placement()
        };
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
